/**
 * Inicializa Google Tag Manager
 * @param {string} gtmId - ID de Google Tag Manager
 */
export const initGTM = (gtmId) => {
  if (!gtmId || typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);
};

/**
 * Envía un evento a Google Tag Manager
 * @param {string} eventName - Nombre del evento
 * @param {object} eventData - Datos del evento
 */
export const sendGTMEvent = (eventName, eventData = {}) => {
  if (typeof window === 'undefined' || !window.dataLayer) return;

  window.dataLayer.push({
    event: eventName,
    ...eventData
  });
};
